export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-it-IT.f9baebb6.xlsx";